import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { AppSettings } from '@core/library/app-settings';
import { BaseService } from './base.service';
import {
  SimpleResponse,
  ListResponse,
} from '@core/models/response-models/response-models';
import {
  TaskSearch,
  TaskGroupSearch,
  TaskUpdate,
  TaskGroupUpdate,
  TaskInfoListResponse,
  TaskGroupTasksUpdate,
} from '@core/models/tasklist/tasklist';
import { Constants } from '@core/utils/constants';

@Injectable({
  providedIn: 'root',
})
export class TasklistService extends BaseService {
  constructor(public apiService: ApiService) {
    super();
    this.BaseURL = AppSettings.URL_KMT;
  }

  TaskGroup_Update(requestObj: TaskGroupUpdate): Promise<SimpleResponse> {
    return this.apiService
      .postAPI(this.BaseURL, 'Tasks/TaskGroup_Update', requestObj)
      .then((data) => {
        return data;
      });
  }

  Task_Update(requestObj: TaskUpdate): Promise<SimpleResponse> {
    return this.apiService
      .postAPI(this.BaseURL, 'Tasks/Task_Update', requestObj)
      .then((data) => {
        return data;
      });
  }

  TaskGroup_Search(requestObj: TaskGroupSearch): Promise<ListResponse> {
    return this.apiService
      .postAPI(this.BaseURL, 'Tasks/TaskGroup_Search', requestObj)
      .then((data) => {
        return data;
      });
  }

  TaskGroup_All(PropertyId: number): Promise<SimpleResponse> {
    const requestObj: TaskGroupSearch = new TaskGroupSearch();
    requestObj.Properties = [];
    requestObj.Properties.push(PropertyId);
    requestObj.PageNumber = 1;
    requestObj.PageSize = Constants.MAX_PAGE_SIZE;

    return this.TaskGroup_Search(requestObj);
  }

  Task_Search(requestObj: TaskSearch): Promise<TaskInfoListResponse> {
    return this.apiService
      .postAPI(this.BaseURL, 'Tasks/Task_Search', requestObj)
      .then((data) => {
        return data;
      });
  }

  Tasks_All(PropertyId: number): Promise<SimpleResponse> {
    const requestObj: TaskSearch = new TaskSearch();
    requestObj.PropertyId = PropertyId;
    requestObj.PageNumber = 1;
    requestObj.PageSize = Constants.MAX_PAGE_SIZE;
    return this.Task_Search(requestObj);
  }

  TaskGroup_WithTasks_Update(
    requestObj: TaskGroupTasksUpdate
  ): Promise<SimpleResponse> {
    return this.apiService
      .postAPI(this.BaseURL, 'Tasks/TaskGroup_WithTasks_Update', requestObj)
      .then((data) => {
        return data;
      });
  }
}
